import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

type FilePreviewModalProps = {
  src: string
  type: 'image' | 'pdf'
  onClose: () => void
  show: boolean
}

const FilePreviewModal = ({
  src,
  type,
  onClose,
  show,
}: FilePreviewModalProps) => {
  return (
    <Dialog open={show} onClose={onClose} maxWidth="xl" fullWidth scroll="paper">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Preview
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {type === 'image' ? (
          <img
            src={src}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
            }}
          />
        ) : (
          <iframe
            src={src}
            title="PDF Preview"
            style={{
              width: '100%',
              height: '80vh',
              border: 'none',
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FilePreviewModal
